export default "__VITE_ASSET__pzDTiUfB__"